export const SESSION_TOKEN_ENUM = 'sessionToken';
export const REFRESH_TOKEN_ENUM = 'refreshToken';
export const SCREEN_ID_ENUM = 'screenId';
export const SCREEN_LAYOUT_ENUM = 'screenLayout';
export const PUBLISH_ID = 'publishId';
export const PLAYER_ORIENTATION = 'playerOrientation';
export const UNIQUE_SCREEN_CODE = 'uniqueScreenCode';
export const USER_VISUALIZATION_TOKEN = 'user-visualization-token';
export const UNIQUE_SCREEN_IDENTIFIER = 'uniqueScreenIdentifier';
export const WATCHDOG_ENABLED = 'watchdogEnabled';
export const ON_OFF_SCHEDULES = 'on-off-schedules';

export const CONTENT_TYPE_WEATHER_APP = 'app/weather';

export const SOCKET_ERROR_TYPES = {
  EXPIRED_TOKEN: 'expired_token',
};

export const REFRESH_LAYOUT_STATUS = {
  SELECTING: 'SELECTING',
  RESIZING: 'RESIZING',
  MOVING: 'MOVING',
  STAND_BY: 'STAND_BY',
  UPDATING: 'UPDATING',
};

export const SCREEN_ORIENTATION = {
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait',
  REVERSE_LANDSCAPE: '180d',
  REVERSE_PORTRAIT: '270d',
};

export const DAYS_OF_THE_WEEK = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const DISPLAY_PRIORITY = {
  PRIORITY: 'priority',
  STANDARD: 'standard',
  FALLBACK: 'backup',
};

export const CHECK_VALIDATION_CODE_INTERVAL = 5000;

export const ANDROID_LOCAL_FILE_KEY = 'android-local-file';

export const EXPECTED_LOGOUT = 'expected-logout';
export const TIZEN_LOCAL_FILE_KEY = 'tizen-local-file';
export const IS_NOTIFICATION_ALREADY_SENT = 'notification-sent';

export const ORGANISATION_WAIT_INTERVAL_MS = 500;
export const ORGANISATION_WAIT_MAX_ATTEMPTS = 10;

export const LAST_CHECKED_AT = 'lastCheckedAt';
export const SCREEN_DOWNTIME_RECORDS = 'screenDowntimeRecords';
